import React, { useContext, useEffect, useState } from 'react';
import { purify } from '../../utils/helpers';
import { Type } from '@spotify-internal/encore-web';
import DeviceContext from '../../configuration/context/device';
import EmbeddedContext from '../../configuration/context/embedded';
function LegalTerms(props) {
    const { className } = props;
    let { text } = props;
    const device = useContext(DeviceContext);
    const { isEmbedded } = useContext(EmbeddedContext);
    const [isMobile, setIsMobile] = useState(device.platform === 'ios');
    useEffect(() => {
        if (device.platform === 'ios') {
            setIsMobile(true);
        }
    }, [device]);
    const targetRegex = /href="([^"]*)"/gim;
    if (isMobile || isEmbedded) {
        text = text.replace(targetRegex, (_target, match) => {
            return match.includes('/legal/')
                ? `href="${match}${match.endsWith('/') ? '' : '/'}plain/"`
                : `href="${match}"`;
        });
    }
    return (React.createElement(Type.p, { className: className, variant: "finale", dangerouslySetInnerHTML: {
            __html: purify(text),
        } }));
}
export default LegalTerms;
//# sourceMappingURL=legalTerms.js.map